const ttiTestingLaboratories = {
  pageTitle: "Visiomate - TTI Testing Laboratories Case Study",
  metaDescription:
    "Visiomate connected TTI Testing Laboratories' lab system to Odoo and automated HR, loan and leave workflows, with live dashboards for leadership.",
  clientName: "TTI Testing Laboratories",
  bannerSummary: "A lab system connected to Odoo for an international textile testing laboratory",
  introHeading: "ERP and System Integration for TTI Testing Laboratories",
  heroImageAlt: "Textile manufacturing machinery",
  about:
    "TTI Testing Laboratories is an ISO-accredited testing and inspection body headquartered in Lahore, Pakistan, and the first lab in the country approved by the US Consumer Product Safety Commission. It tests textiles, leather, chemicals, oil and gas and environmental samples, and serves global buyers and brands across 17 countries.",

  challengesIntro: "Laboratory data, finance and HR were running in separate worlds.",
  challenges: [
    {
      title: "Isolated Laboratory Data",
      desc: "Data in the lab system sat apart from everything else, leaving gaps in visibility.",
    },
    {
      title: "No Unified Financial Reporting",
      desc: "Laboratory results couldn't feed one joined-up financial picture.",
    },
    {
      title: "Paper-Based HR",
      desc: "Loans and payroll ran on paper workflows, causing constant delays.",
    },
    {
      title: "Low Visibility for Management",
      desc: "Leadership had no real-time access to company-wide KPIs.",
    },
  ],

  solutionsIntro: "We connected the lab to Odoo and automated the paperwork around it.",
  solutions: [
    {
      num: "01",
      text: "Lab System Integration",
      desc: "The existing laboratory system linked to Odoo so data flows into reporting automatically.",
    },
    {
      num: "02",
      text: "HR and Loan System",
      desc: "The whole employee lifecycle and loan workflows automated for accurate payroll deductions.",
    },
    {
      num: "03",
      text: "Self-Service Portal",
      desc: "Employees manage leave themselves, reducing HR workload.",
    },
    {
      num: "04",
      text: "Executive Dashboards",
      desc: "Real-time tracking brings data together for immediate decisions.",
    },
  ],

  resultsIntro: "TTI now runs as one connected organisation.",
  metrics: [
    { metric: "100%", label: "Of laboratory data linked to core accounting" },
    { metric: "Real time", label: "Company-wide KPIs and analytics for leadership" },
    { metric: "Automated", label: "Loan, payroll and leave workflows, replacing paper" },
  ],
  outcomes: [
    "Leadership moves from guesswork to data-driven decisions",
    "Odoo and the legacy lab system stay reconciled",
    "Staff handle leave through a portal, and HR spends less time on admin",
  ],

  relatedLinks: [
    {
      to: "/caseStudies/projects/netAtlantic",
      label: "Read the Net Atlantic story",
      note: "A rebuilt email marketing platform, 35% faster campaign deployment.",
    },
    {
      to: "/caseStudies/projects/centricEvents",
      label: "See the Centric Events story",
      note: "One connected system from first enquiry to final invoice.",
    },
  ],
}

export default ttiTestingLaboratories
